<template lang="pug">
div(:style="{'background-color': getStyle().background}").pa-3.mt-4.mb-4.panel
  v-layout(row,wrap)
    v-flex.md12.xs12
      label.title(:style="{'color' : getStyle().color}") {{title}}
      br
      label.message(:style="{'color' : getStyle().color}") {{message}}
      div(v-if="cta")
        br
        label.cta(:style="{'color' : getStyle().color}", @click="cta.action()") {{cta.text}}
          v-icon.cta.pl-2(:style="{'color' : getStyle().color}") arrow_forward
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
      required: true,
    },
    message: {
      type: String,
      default: null,
      required: false,
    },
    cta: {
      type: Object,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: null,
      required: false,
    },
  },
  data () {
    return {
      INFO: "info",
      WARNING: "warning",
      SUCCESS: "success",
      DANGER: "danger",
    }
  },
  methods: {
    getStyle () {
      const vm = this;
      const style = {};
      style[vm.INFO] = {
        background: '#0060C80A',
        color: '#0060C8'
      }
      style[vm.WARNING] = {
        background: '#FF950014',
        color: '#FF9500'
      }
      style[vm.SUCCESS] = {
        background: '#1D9A5A14',
        color: '#0F7641'
      }
      style[vm.DANGER] = {
        background: '#D632320A',
        color: '#D63232'
      }
      return style[vm.type] || style[vm.INFO];
    },
  },
}
</script>

<style scoped>
  .panel {
    border-radius:8px
  }

  .title {
    font-size:16px;
    font-weight: 500;
  }

  .message {
    font-size:16px;
    font-weight: 400;
  }

  .cta {
    font-size:18px;
    font-weight: bold;
    cursor: pointer;
  }
</style>
